import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "order" };
const _hoisted_2 = { class: "order__header" };
const _hoisted_3 = { class: "order__orderNumber" };
const _hoisted_4 = {
    key: 0,
    class: "order__orderedDate"
};
const _hoisted_5 = {
    key: 1,
    class: "order__orderedDate"
};
const _hoisted_6 = { class: "order__branch" };
const _hoisted_7 = {
    key: 0,
    class: "order__supplierBranchInformation"
};
const _hoisted_8 = { class: "order__shipping" };
const _hoisted_9 = { class: "order__comment" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "order__comment--line" };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { class: "order__comment--line" };
const _hoisted_14 = { class: "order__items" };
const _hoisted_15 = { class: "table table--condensed" };
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = { class: "order__quantity" };
const _hoisted_19 = { class: "order__quantity" };
const _hoisted_20 = { class: "order__quantity" };
const _hoisted_21 = { class: "order__quantity" };
const _hoisted_22 = { class: "order-total" };
const _hoisted_23 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_24 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_25 = { class: "order__tax" };
const _hoisted_26 = { class: "order__tax-label" };
const _hoisted_27 = { class: "order__tax-netto" };
const _hoisted_28 = { class: "order__tax-value" };
const _hoisted_29 = { class: "order-total" };
const _hoisted_30 = {
    colspan: "2",
    class: "order__quantity"
};
const _hoisted_31 = {
    key: 0,
    class: "order__receipt"
};
const _hoisted_32 = { class: "order__receipt__images--title" };
const _hoisted_33 = { class: "order__receipt__images" };
const _hoisted_34 = ["src", "onClick"];
import { computed } from "vue";
import moment from "moment/moment";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import VensoInvoiceRequestOrderItem from "@/components/VensoInvoiceRequestOrderItem.vue";
import { formatCHF } from "@/utils/currency";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoInvoiceRequestOrder',
    props: {
        order: {},
        supplier: {}
    },
    setup(__props) {
        const props = __props;
        function findNoticeItem(orderItem) {
            return props.order.deliveryNotice?.items.find(item => item.position === orderItem.position) ?? null;
        }
        function findReceiptItem(orderItem) {
            return props.order.deliveryReceipt?.items.find(item => item.position === orderItem.position) ?? null;
        }
        const noticeLocked = computed(() => props.order.deliveryNotice?.status === 'locked' || props.order.deliveryReceipt != null);
        const orderDateFormatted = computed(() => {
            return props.order && moment(props.order.orderedAt).format('dddd, DD.MM.YYYY');
        });
        const deliveryDateFormatted = computed(() => {
            return props.order && props.order.deliveryReceipt && moment(props.order.deliveryReceipt.metadata.timestamp).format('dddd, DD.MM.YYYY');
        });
        const deliveryReceiptTotal = computed(() => {
            let total = 0;
            if (!props.order || !props.order.deliveryReceipt) {
                return formatCHF(total);
            }
            for (let item of props.order.allItems) {
                let quantity = item.quantity;
                let receiptItem = findReceiptItem(item);
                let noticeItem = findNoticeItem(item);
                if (receiptItem != null) {
                    quantity = receiptItem.receivedQuantity;
                }
                else if (noticeItem != null) {
                    quantity = noticeItem.quantity;
                }
                total += (quantity * Number(item.unitPrice));
            }
            return formatCHF(total);
        });
        function formatTimestamp(ts) {
            return moment(ts).format('DD.MM.YYYY, HH:mm');
        }
        function openImage(uri) {
            window.open(uri, '_blank');
        }
        const taxSummary = computed(() => {
            const groups = new Map();
            for (const item of props.order.allItems) {
                const key = item.taxRate ?? '0';
                // invoicing rule:
                // 1. received quantity (Wareneingang)
                // 2. announced quantity (Avisierung)
                // 3. fall back to the ordered position total
                const receiptItem = findReceiptItem(item);
                const noticeItem = findNoticeItem(item);
                let netto;
                if (receiptItem != null) {
                    netto = receiptItem.receivedQuantity * Number(item.unitPrice);
                }
                else if (noticeItem != null) {
                    netto = Number(noticeItem.positionTotal ?? 0);
                }
                else {
                    netto = Number(item.positionTotal ?? 0);
                }
                const existing = groups.get(key);
                if (existing) {
                    existing.netto += netto;
                }
                else {
                    groups.set(key, { taxRate: Number(item.taxRate ?? 0), netto });
                }
            }
            return Array.from(groups.values())
                .sort((a, b) => a.taxRate - b.taxRate)
                .map(g => ({
                taxRate: g.taxRate,
                netto: roundRappen(g.netto),
                tax: roundRappen(g.netto * g.taxRate),
            }));
        });
        const totalBrutto = computed(() => roundRappen(taxSummary.value.reduce((sum, g) => sum + g.netto + g.tax, 0)));
        function roundRappen(value) {
            return Math.sign(value) * Math.round(Math.abs(value) * 100 + Number.EPSILON) / 100;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _createTextVNode("#" + _toDisplayString(__props.order.orderNumber) + " ", 1),
                        (orderDateFormatted.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                _createVNode(Icon, {
                                    name: "shopping-cart",
                                    title: _ctx.$t('venso_order.order')
                                }, null, 8, ["title"]),
                                _createTextVNode(_toDisplayString(orderDateFormatted.value), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (deliveryDateFormatted.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(Icon, {
                                    name: "truck",
                                    title: _ctx.$t('venso_order.delivery')
                                }, null, 8, ["title"]),
                                _createTextVNode(_toDisplayString(deliveryDateFormatted.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.order.branch.name), 1),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (__props.order.supplierBranchInformation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('venso_order.supplierBranchInformation.customerNumber')) + " " + _toDisplayString(__props.order.supplierBranchInformation.customerNumber), 1))
                        : _createCommentVNode("", true),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('venso_order.shipping_to')) + " " + _toDisplayString(__props.order.branch.address) + ",\n                " + _toDisplayString(__props.order.branch.zip) + " " + _toDisplayString(__props.order.branch.city), 1),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.$t('venso_order.comment')) + " ", 1),
                        (__props.order.deliveryNotice?.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("span", null, [
                                    _createVNode(Icon, {
                                        name: "clipboard",
                                        title: _ctx.$t('venso_order.notice')
                                    }, null, 8, ["title"]),
                                    _createTextVNode(" " + _toDisplayString(__props.supplier.name) + " " + _toDisplayString(formatTimestamp(__props.order.deliveryNotice.metadata.timestamp)), 1)
                                ]),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(__props.order.deliveryNotice.comment), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.order.deliveryReceipt?.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("span", null, [
                                    _createVNode(Icon, {
                                        name: "truck",
                                        title: _ctx.$t('venso_order.delivery')
                                    }, null, 8, ["title"]),
                                    _createTextVNode(" " + _toDisplayString(__props.order.deliveryReceipt.metadata.actor) + " " + _toDisplayString(formatTimestamp(__props.order.deliveryReceipt.metadata.timestamp)), 1)
                                ]),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(__props.order.deliveryReceipt.comment), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[30] || (_cache[30] = _createTextVNode()),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_order.items')), 1),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _cache[9] || (_cache[9] = _createElementVNode("th", null, null, -1)),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("th", {
                                    class: "order__quantity",
                                    innerHTML: _ctx.$t('venso_order_item.base_price')
                                }, null, 8, _hoisted_16),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("th", {
                                    class: "order__quantity",
                                    innerHTML: _ctx.$t('venso_order_item.price')
                                }, null, 8, _hoisted_17),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('venso_order_item.total')), 1),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('venso_order_item.quantity_ordered')), 1),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('venso_order_item.quantity_notified')), 1),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('venso_order_item.quantity_received')), 1)
                            ])
                        ]),
                        _cache[27] || (_cache[27] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.allItems, (item, index) => {
                                return (_openBlock(), _createBlock(VensoInvoiceRequestOrderItem, {
                                    item: item,
                                    currency: __props.order.currency,
                                    noticeItem: findNoticeItem(item),
                                    locked: noticeLocked.value,
                                    key: index,
                                    receiptItem: findReceiptItem(item)
                                }, null, 8, ["item", "currency", "noticeItem", "locked", "receiptItem"]));
                            }), 128)),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            _createElementVNode("tr", _hoisted_22, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t('venso_order.total_net')) + " " + _toDisplayString(__props.order.currency) + " " + _toDisplayString(deliveryReceiptTotal.value), 1)
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxSummary.value, (tax) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: tax.taxRate,
                                    class: "order-total order-total--tax"
                                }, [
                                    _cache[20] || (_cache[20] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('venso_order_item.tax')) + " " + _toDisplayString(_unref(formatCHF)(tax.taxRate * 100)) + "%\n                                ", 1),
                                                _cache[18] || (_cache[18] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_27, "\n                                    (" + _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(tax.netto)) + ")\n                                ", 1)
                                            ]),
                                            _cache[19] || (_cache[19] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_28, _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(tax.tax)), 1)
                                        ])
                                    ])
                                ]));
                            }), 128)),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            _createElementVNode("tr", _hoisted_29, [
                                _cache[22] || (_cache[22] = _createElementVNode("td", { colspan: "3" }, null, -1)),
                                _cache[23] || (_cache[23] = _createTextVNode()),
                                _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.$t('venso_order.total_brutto')) + " " + _toDisplayString(__props.order.currency) + " " + _toDisplayString(_unref(formatCHF)(totalBrutto.value)), 1)
                            ])
                        ])
                    ]),
                    _cache[29] || (_cache[29] = _createTextVNode()),
                    (__props.order.deliveryReceipt && __props.order.deliveryReceipt.deliveryImageUris && __props.order.deliveryReceipt.deliveryImageUris.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("h2", _hoisted_32, _toDisplayString(_ctx.$t('venso_order.delivery_receipt_images')), 1),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.deliveryReceipt.deliveryImageUris, (uri) => {
                                    return _renderSlot(_ctx.$slots, "default", { key: uri }, () => [
                                        _createElementVNode("img", {
                                            src: uri,
                                            onClick: ($event) => (openImage(uri))
                                        }, null, 8, _hoisted_34)
                                    ]);
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
